export const formatNumbers = (value, currency = '') => {
    if (value === 0) return `${currency}0`;

    const isNegative = value < 0;
    const absValue = Math.abs(value);

    if (absValue >= 1e9) return formatCompact(absValue, 1e9, 'B', currency, isNegative);
    if (absValue >= 1e6) return formatCompact(absValue, 1e6, 'M', currency, isNegative);
    if (absValue >= 1e3) return formatCompact(absValue, 1e3, 'K', currency, isNegative);

    const roundedValue = absValue % 1 === 0 ? absValue : absValue.toFixed(1);
    return isNegative ? `-${currency}${roundedValue}` : `${currency}${roundedValue}`;
};

const formatCompact = (value, divisor, suffix, currency, isNegative) => {
    const compactValue = value / divisor;
    const formatted = Number.isInteger(compactValue)
        ? `${currency}${compactValue}${suffix}`
        : `${currency}${compactValue.toFixed(1)}${suffix}`;

    return isNegative ? `-${formatted}` : formatted;
};
